import {ofType} from 'redux-observable';
import {map} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import MealActionTypes from 'web-app/react/entities/meals/meal-plan/action-types';

import * as Actions from './actions';

const mealSettingsUpdated = action$ =>
    action$.pipe(
        ofType(MealActionTypes.MEAL_TYPE_UPDATE_SUCCESS),
        map(() => Actions.hide.action()),
    );

export default combineEpics(mealSettingsUpdated);
